import * as React from 'react'
import Form from '../Form'
import {
  ReservationStepHeader,
  ReservationStepBody,
} from '../ReservationStepHeader'
import { ReservationNote } from '../ReservationNote'

import { TrialLessonIndexView } from '../../types/trialLessons'
import { LessonTypeId } from '../LessonListContent'
import { CurrentUser } from '../../types/currentUser'

type Props = {
  stepText?: string
  id?: string
  jwtToken?: string
  selectedLesson: TrialLessonIndexView
  currentUser?: CurrentUser
  selectedLessonTypeId: LessonTypeId | null
  isRescheduled?: boolean
  reservationId?: string
  isMulticreator?: boolean
  location?: string
}

export const UserFormPane = ({
  stepText = 'STEP2',
  id = 'step2',
  jwtToken = '',
  selectedLesson,
  currentUser,
  selectedLessonTypeId,
  isRescheduled,
  reservationId,
  isMulticreator,
  location,
}: Props) => (
  <div id="user-form-pane">
    <ReservationStepHeader id={id} stepText={stepText}>
      お客様の情報をご入力ください
    </ReservationStepHeader>
    <ReservationStepBody>
      <div className="desktop:max-w-[600px] desktop:my-10 desktop:mx-auto desktop:mb-20 tablet:my-10 tablet:mx-10 tablet:mb-20 sp:my-[8.53vw] sp:mx-4 sp:mb-[21.33vw]">
        <Form
          jwtToken={jwtToken}
          selectedLesson={selectedLesson}
          currentUser={currentUser}
          selectedLessonTypeId={selectedLessonTypeId}
          isRescheduled={isRescheduled}
          reservationId={reservationId}
          isMulticreator={isMulticreator}
          location={location}
        />
        <ReservationNote />
      </div>
    </ReservationStepBody>
  </div>
)
